import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var InboxPreferencesTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(InboxPreferencesTransformer, _BaseTransformer);
  var _super = _createSuper(InboxPreferencesTransformer);
  function InboxPreferencesTransformer() {
    _classCallCheck(this, InboxPreferencesTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(InboxPreferencesTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return _objectSpread({}, data);
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return InboxPreferencesTransformer;
}(BaseTransformer);